$(document).ready(function () {
    var $paginationNav = $('.js-pagination'),
        $paginationDropdown = $('.js-pagination__dropdown'),
        $blogListing = $('.js-bloglisting'),
        $blogListingCategory = $('.js-bloglisting__category'),
        $blogListingSearch = $('.js-bloglisting__search'),
        $paginationNext = $('[data-direction="next"]'),
        $paginationPrev = $('[data-direction="prev"]');

    var appData = {
        page: 1,
        category: '',
        search: '',
        pageId: parseInt($blogListing.data('page'))
    };

    $paginationNav.on('click', function (e) {
        e.preventDefault();
        if ($(this).data('direction') == 'next') {
            appData.page += 1;
        } else {
            appData.page -= 1;
        }

        changePage();
    });

    $blogListingCategory.change(function (e) {
        appData.page = 1;
        appData.category = e.target.value;
        changePage();
    });

    $blogListingSearch.on('keyup', function (e) {
        appData.search = e.target.value;
        clearTimeout($.data(this, 'timer'));
        var wait = setTimeout(changePage, 500);
        $(this).data('timer', wait);
    });

    $paginationDropdown.change(function (e) {
        e.preventDefault();
        appData.page = parseInt(e.target.value);
        changePage();
    });

    function changePage() {

        $.ajax({
            type: "POST",
            url: "/umbraco/surface/BlogListingSurface/RenderBlogListing",
            data: appData,
            success: function (response) {

                if (appData.page > response.TotalPages) {
                    appData.page = 1;
                }

                $paginationDropdown.empty();

                for (var i = 1; i <= response.TotalPages; i++) {
                    $paginationDropdown.append($('<option>', {
                        value: i.toString(),
                        text: "Page "+i.toString()
                    }));
                }

                $paginationDropdown.val(appData.page);

                $blogListing.html(response.Html);

                if (appData.page > 1 && appData.page < response.TotalPages) {
                    $paginationPrev.removeClass('disabled');
                    $paginationNext.removeClass('disabled');
                }

                if (appData.page == response.TotalPages) {
                    $paginationNext.addClass('disabled');
                    $paginationPrev.removeClass('disabled');
                }
                if (appData.page == 1) {
                    $paginationPrev.addClass('disabled');
                    $paginationNext.removeClass('disabled');
                }
                processor.Run();
                scrollToBlogListings();
            },
            error: function (xhr, status, error) {
                console.log(xhr);
            }
        });
    }

    function scrollToBlogListings() {
        var position = $blogListing.position();
        var top = position.top;
        window.scrollTo(0, top);
    }
});